import React, { useState } from 'react';
import ChatWindow from '../ChatWindow';

/**
 * Scoped "Ask" panel — embeds ChatWindow with the `channel-intelligence` agent profile.
 * That profile runs a CURATED toolset (query_channel_intelligence, list_intelligence_channels,
 * channel earnings, network YouTube performance) with a focused system prompt and no Google
 * Workspace MCP — so answers are fast, accurate, and stay inside Channel Intelligence; anything
 * out of scope gets a one-line redirect to the main Chat.
 */
const AskTab: React.FC<{ userOrganization?: string }> = ({ userOrganization }) => {
  const [sessionId, setSessionId] = useState<string | null>(null);

  // Explicit height so ChatWindow's height:100% resolves — a min-height-only
  // parent gives it nothing to fill, breaking its internal scroll. vh (not
  // dvh): browsers without dvh drop the whole declaration, and inline styles
  // can't carry a fallback pair.
  return (
    <div style={{ height: 'min(70vh, 720px)', minHeight: 480, border: '1px solid var(--border-1)', borderRadius: 'var(--radius-lg)', overflow: 'hidden' }}>
      <ChatWindow
        selectedSessionId={sessionId}
        userOrganization={userOrganization}
        onSessionChange={setSessionId}
        agentProfile="channel-intelligence"
        embedded
      />
    </div>
  );
};

export default AskTab;
